import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { NovedadesMes } from '../models/novedadesMes';

const baseUrl = environment.hostService + '/NominasEspeciales';

@Injectable({
  providedIn: 'root'
})
export class NominasEspecialesService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonal(id: number, agrupar: boolean): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + id + '/' + agrupar })
  }

  getHistoryByClase(idPersonal: number, codigoMotivo: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByMotivo/' + idPersonal + '/' + codigoMotivo });
  }

  guardar(data, cortarRegistro): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: data, cacheMins: 0 });
  }

  eliminar(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        fecha: '00/00/0000',
        motivoNominaEspecial: '',
        codigosNomina: '',
        cantidad: '',
        importe: '',
        moneda: '',
        errores: ['No Completar']}
    ];

    //codigosNomina, motivoNominaEspecial, moneda se deben validar que existan

    return formato;
  }

}
